var React = require('react');

function IconAngleRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M199.6,177.1l-136,136c-9.4,9.4-24.6,9.4-33.9,0L7.1,290.4c-9.4-9.4-9.4-24.6,0-33.9l96.4-96.4L7,63.8\n\tc-9.4-9.4-9.4-24.6,0-33.9L29.6,7.1c9.4-9.4,24.6-9.4,33.9,0l136,136C208.9,152.4,208.9,167.7,199.6,177.1z"}));
}

IconAngleRightInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 206.6 320.1","style":{"enableBackground":"new 0 0 206.6 320.1"},"xmlSpace":"preserve"};

module.exports = IconAngleRightInline;

IconAngleRightInline.default = IconAngleRightInline;
